import {Injectable, Pipe, PipeTransform} from '@angular/core';

/**
 * bolds the beggining of the matching string in the item
 */
@Pipe({
    name: 'boldprefix',
    standalone: false
})
@Injectable()
export class BoldPrefix implements PipeTransform {
  transform(value: string, keyword: string): any {
    if (!keyword) {
      return value;
    }
    const escaped_keyword = keyword.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    return value.replace(new RegExp(escaped_keyword, 'gi'), str => str.bold());
  }
}
